import { toBackendTimestamp } from '@/utils/api/toBackendTimestamp'
import { type ColumnSort, toOrderByParams } from '@/utils/table/columnSort'

import type {
  UsersEnabledFilter,
  UsersFilterParams,
  UsersFilters,
  UsersSortField,
} from '../types/users.types'

export const INITIAL_USERS_FILTERS: UsersFilters = {
  description: '',
  login: '',
  enabled: 'ALL',
  createdAt: { from: null, to: null },
}

export const USERS_ENABLED_OPTIONS: {
  value: UsersEnabledFilter
  label: string
}[] = [
  { value: 'ALL', label: 'Все пользователи' },
  { value: 'ENABLED', label: 'С доступом' },
  { value: 'DISABLED', label: 'Без доступа' },
]

const ENABLED_PARAM: Record<UsersEnabledFilter, boolean | undefined> = {
  ALL: undefined,
  ENABLED: true,
  DISABLED: false,
}

export const isUsersEnabledFilter = (
  value: unknown
): value is UsersEnabledFilter =>
  USERS_ENABLED_OPTIONS.some((option) => option.value === value)

const toSearchParam = (value: string) => value.trim() || undefined

export const toUsersFilterParams = (
  filters: UsersFilters,
  sort: ColumnSort<UsersSortField>
): UsersFilterParams => ({
  description: toSearchParam(filters.description),
  login: toSearchParam(filters.login),
  enabled: ENABLED_PARAM[filters.enabled],
  createdAtFrom: toBackendTimestamp(filters.createdAt.from),
  createdAtTo: toBackendTimestamp(filters.createdAt.to),
  ...toOrderByParams(sort),
})
